module.exports = "<div class=\"inset\">\n    <div layout=\"row\">\n        <tabs-list flex=\"20\"></tabs-list>\n        <div ui-view=\"content\" flex=\"70\" flex-offset=\"5\"></div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/stepPedagogicalApproachView.html
// module id = 286
// module chunks = 0